// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 936 ? "__federation_expose_Module" : chunkId) + "." + {"27":"7abbe89361794503","195":"7abbe89361794503","259":"7abbe89361794503","263":"7625d23c7f967b70","936":"043908bf012cf727"}[chunkId] + ".css";
};